import type { SVGProps } from 'react';
const CheckUploaded = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width={32}
        height={32}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <rect width={32} height={32} rx={16} fill="#F18F34" />
        <path
            d="M23.4665 10.3994L13.1999 20.6661L8.5332 15.9994"
            stroke="white"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
export default CheckUploaded;
